import { Button } from "../../../../components/ui/common/button";
import { IngredientDetailsViewModel } from "../types/ingredientDetailsView.types";

interface IngredientDetailsFooterProps {
  vm: IngredientDetailsViewModel;
}

/**
 * Bottom action bar — Cancel / Edit / Calculate-or-Ingredient-Mapping,
 * matching the legacy `MainBottomMultipleButtonView` layout
 * (leftButtons: Cancel, rightButtons: Edit + Calculate/Ingredient Mapping).
 * Built from plain `Button`s rather than the shared
 * `TailwindBottomButtonView` since that component only supports a single
 * primary action plus a destructive-styled secondary one, neither of which
 * fits "Edit" here.
 */
const IngredientDetailsFooter = ({ vm }: IngredientDetailsFooterProps) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-border-t tw-border-border tw-px-6 tw-py-4">
      <Button type="button" variant="outline" onClick={vm.onCancel}>
        Cancel
      </Button>
      <div className="tw-flex tw-gap-2">
        <Button type="button" variant="outline" onClick={vm.onEdit}>
          Edit
        </Button>
        {vm.enableIngredientMapping ? (
          <Button type="button" onClick={vm.onIngredientButtonClick}>
            {vm.ingredientButtonTitle}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default IngredientDetailsFooter;
